<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="unreadNotifications.length" />

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white">{{ unreadNotifications.length }} Nouvelles</h3>
        <p class="opacity-75">Notifications</p>
      </div>

      <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" :key="$vs.rtl">
        <ul class="bordered-items">
          <!-- get_window.SingleRequestApp.general() -->
          <li v-for="ntf in unreadNotifications" :key="ntf.index" @click="goToSingle(ntf.id, ntf.has_proved, ntf.type), notifications_read(ntf.uid)" class="flex justify-between px-4 py-4 notification cursor-pointer">
            <div class="flex items-start">
              <feather-icon :icon="ntf.icon" :svgClasses="[`text-${ntf.category}`, 'stroke-current mr-1 h-6 w-6']"/>
              <div class="mx-2">
                <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ ntf.title }}</span>
                <small>{{ ntf.msg }}</small>
              </div>
            </div>
            <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.created_at) }}</small>

            <feather-icon
              icon="StarIcon"
              class="cursor-pointer"
              :svgClasses="[{'text-warning stroke-current': ntf.is_important}, 'w-5', 'h-5 mr-4']"
              @click.stop="ntf.is_important = true, notifications_read(ntf.uid)" />
          </li>
        </ul>
      </VuePerfectScrollbar>

      <div class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer">
        <!-- <span>Toutes les notifications</span> -->
      </div>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
var base_self;
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      not_data: {},
      unreadNotifications: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60,
      },
    }
  },
  computed: {
    get_window () {
      return window;
    }
  },
  methods: {
    goToSingle(id, el, type) {
      switch (type) {
        case 'cei':
          this.$router.push('/requests/mail');
          break;
        case 'alert':
          this.$router.push('/statistics/manager');
          break;
          default:
            let t = el ? 1 : 2
            this.$router.push('/requests/' + id + '/detail/'+t)
              break;
      }
      /*
      if (type == 'cei'){
        this.$router.push('/requests/mail')
      }else{
        let t = el ? 1 : 2
        this.$router.push('/requests/' + id + '/detail/'+t)
      }
      */
    },
    elapsedTime(startTime) {
      let x        = new Date(startTime);
      let now      = new Date();
      var timeDiff = now - x;
      timeDiff    /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff    = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff    = Math.floor(timeDiff / 60);

      var hours   = Math.round(timeDiff % 24);
      timeDiff    = Math.floor(timeDiff / 24);

      var days    = Math.round(timeDiff % 365);
      timeDiff    = Math.floor(timeDiff / 365);

      var years   = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? ' Years ' : ' Year ') + 'ago'
      } else if (days > 0) {
        return days + (days > 1 ? ' Days ' : ' Day ') + 'ago'
      } else if (hours > 0) {
        return hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago'
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago'
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' sec ago' : 'just now')
      }

      return 'Just Now'
    },
    // Method for creating dummy notification time
    randomDate({ hr, min, sec }) {
      let date = new Date();

      if (hr) date.setHours(date.getHours() - hr);
      if (min) date.setMinutes(date.getMinutes() - min);
      if (sec) date.setSeconds(date.getSeconds() - sec);

      return date
    },
    async notifications_read (uid) {
      let response = await base_self.$store.state.notifications_read({ uid });
      if (response.data.status) {
        //window.GETCCMT.success('La notification est marquée comme lu.', response);
        base_self.get_notifications();
      } else {
        window.GETCCMT.error({ message: 'Le marquage de la notification a échouée.' });
      }
    },
    async get_notifications () {
      let response = await base_self.$store.state.notifications({});

      var length = response.data.length;
      var array = [];

      for (let iuoy = 0; iuoy < length; iuoy++) {
        var item = response.data[iuoy];

        array.push({
          id: item.id,
          icon: (item.type === "request") ? 'MessageSquareIcon' : (item.type === "approbation") ? 'CheckSquareIcon' : '',
          category: (item.type === "request") ? 'primary' : (item.type === "approbation") ? 'default' : '',
          time: this.randomDate({sec: 10}),
          title: item.head,
          msg: item.title,
          type: item.type,
          uid: item.uid,
          user_id: item.user_id,
          created_at: item.created_at,
          is_important: false,
          has_proved: item.has_proved
        });
      }
      base_self.unreadNotifications = array;
    }
  },
  mounted() {
    // base_self.get_notifications();

    // window.notification = setInterval(() => {
    //   base_self.get_notifications()
    // }, 10000)
  },
  created() {
    base_self = this;
    window.NotificationDropDownApp = this;
  }
}

</script>

